import { render } from "./wallet_list.vue?vue&type=template&id=1f6763bd"
import script from "./wallet_list.vue?vue&type=script&lang=js"
export * from "./wallet_list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__